import { useEffect, useState } from "react";

export function videoFilePreviewKey(file: File): string {
  return `${file.name}-${file.size}-${file.lastModified}`;
}

function filesSignature(files: File[]): string {
  return files.map(videoFilePreviewKey).join("|");
}

/** Object URLs for local video files; revoked when files change or component unmounts. */
export function useVideoPreviewUrls(files: File[]): Record<string, string> {
  const [urlByKey, setUrlByKey] = useState<Record<string, string>>({});
  const signature = filesSignature(files);

  useEffect(() => {
    const next: Record<string, string> = {};
    for (const file of files) {
      const key = videoFilePreviewKey(file);
      next[key] = URL.createObjectURL(file);
    }

    setUrlByKey((prev) => {
      for (const url of Object.values(prev)) {
        URL.revokeObjectURL(url);
      }
      return next;
    });

    return () => {
      for (const url of Object.values(next)) {
        URL.revokeObjectURL(url);
      }
    };
  }, [signature]);

  return urlByKey;
}
